import { TableName } from "../EditableTable/options";
import actions from "./actions";
import Big from "big.js";

let openingItems, totals;

const initState = {
    currentStep: null,
    readState: null,
    updateState: null,
    updateErrorMsg: "",
    opening: {},
    date: null,
    debitTotal: "0.00",
    creditTotal: "0.00",

    pagination: {
        [TableName.opening_bill]: {
            current: 1,
            pageSize: 10,
            total: null,
        },
        [TableName.opening_invoice]: {
            current: 1,
            pageSize: 10,
            total: null,
        },
        [TableName.opening_stock_adjustment]: {
            current: 1,
            pageSize: 10,
            total: null,
        },
    },

    readImportedProductsDetailState: false,
    importedProductsDetailList: [],
};

const calculateTotals = openingItems => {
    let debitTotalB = new Big(0);
    let creditTotalB = new Big(0);
    let itemAmountB;
    openingItems.forEach(item => {
        itemAmountB = new Big(item.amount || 0);
        itemAmountB = itemAmountB.times(item.exchange_rate || 1).round(2);
        if (itemAmountB.gte(0))
            creditTotalB = creditTotalB.plus(itemAmountB);
        else
            debitTotalB = debitTotalB.plus(itemAmountB.abs());

        if (item.children) {
            item.children.forEach(item2 => {
                itemAmountB = new Big(item2.amount);
                itemAmountB = itemAmountB.times(item2.exchange_rate || 1).round(2);
                if (itemAmountB.gte(0))
                    creditTotalB = creditTotalB.plus(itemAmountB);
                else
                    debitTotalB = debitTotalB.plus(itemAmountB.abs());
            });
        }
    });

    return {
        debitTotal: debitTotalB.toFixed(2),
        creditTotal: creditTotalB.toFixed(2),
    };
};

export default function appReducer(state = initState, action = {}) {
    switch (action.type) {
        case actions.OPENING_SET_CURRENT_STEP:
            return {
                ...state,
                currentStep: action.currentStep,
            };
        case actions.OPENING_CALCULATE_TOTAL:
            totals = calculateTotals(action.opening_items);
            return {
                ...state,
                debitTotal: totals.debitTotal,
                creditTotal: totals.creditTotal,
            };
        case actions.OPENING_READ_REQUEST:
            return {
                ...state,
                readState: 'request',
            };
        case actions.OPENING_READ_SUCCESS:
            totals = calculateTotals(action.transaction.opening_items);

            return {
                ...state,
                readState: 'success',
                opening: action.transaction,
                openingItems,

                stockItems: action.transaction.opening_stocks,
                invoiceItems: action.transaction.invoices,
                billItems: action.transaction.bills,

                pagination: {
                    ...state.pagination,
                    [TableName.opening_stock]: {
                        ...state.pagination[TableName.opening_stock],
                        total: action.transaction.opening_stocks.length,
                    },
                    [TableName.opening_invoice]: {
                        ...state.pagination[TableName.opening_invoice],
                        total: action.transaction.invoices.length,
                    },
                    [TableName.opening_bill]: {
                        ...state.pagination[TableName.opening_bill],
                        total: action.transaction.bills.length,
                    },
                },

                debitTotal: totals.debitTotal,
                creditTotal: totals.creditTotal,
            };
        case actions.OPENING_UPDATE_REQUEST:
            return {
                ...state,
                updateState: 'request',
            };
        case actions.OPENING_UPDATE_SUCCESS:
            return {
                ...state,
                updateState: 'success',
            };
        case actions.OPENING_UPDATE_ERROR:
            return {
                ...state,
                updateState: 'error',
                updateErrorMsg: action.error.message,
            };
        case actions.OPENING_SET_DATE:
            return {
                ...state,
                date: action.date,
            };
        case actions.OPENING_SET_PAGINATION: {
            return {
                ...state,
                pagination: {
                    ...state.pagination,
                    [action.tableName]: action.paginationData,
                },
            };
        }
        case actions.OPENING_READ_IMPORTED_PRODUCTS_DETAIL_REQUEST:
            return {
                ...state,
                readImportedProductsDetailState: 'request',
            };
        case actions.OPENING_READ_IMPORTED_PRODUCTS_DETAIL_SUCCESS:
            return {
                ...state,
                readImportedProductsDetailState: 'success',
                importedProductsDetailList: action.importedProductsDetailList,
            };
        case actions.OPENING_READ_IMPORTED_PRODUCTS_DETAIL_ERROR:
            return {
                ...state,
                readImportedProductsDetailState: 'error',
            };
        case actions.OPENING_RESET:
            return {
                ...initState,
            };
        default:
            return state;
    }
}
